import { Routes } from '@angular/router';
import { FAQPageSections } from '@pages/frequently-asked-questions/model/faq.model';

export enum FAQRouteNames {
  MORE_FAQ = 'more-faq',
  FAQ_PROCEDURES = 'procedures',
}

export const FAQ_ROUTES: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('@pages/frequently-asked-questions/main-page/frequently-asked-questions.page').then((p) => p.FrequentlyAskedQuestionsPage),
  },
  {
    path: FAQRouteNames.MORE_FAQ,
    data: {
      breadcrumb: {
        skip: true,
      },
    },
    children: [
      {
        path: FAQRouteNames.FAQ_PROCEDURES,
        data: {
          breadcrumb: () => `FAQ.${FAQPageSections.PROCEDURES}.TITLE`,
        },
        loadComponent: () =>
          import('@pages/frequently-asked-questions/faq-procedures/faq-procedures.page').then((p) => p.FAQProceduresPage),
      },
      {
        path: ':section',
        data: {
          breadcrumb: (section: string) => `FAQ.${section.toUpperCase()}.TITLE`,
        },
        loadComponent: () =>
          import('@pages/frequently-asked-questions/faq-specific-section/faq-specific-section.page').then((p) => p.FaqSpecificSectionPage),
      },
    ],
  },
];
